import React from 'react';
import { Container } from 'semantic-ui-react';
import 'react-virtualized/styles.css';

import { MarketsTable, SearchBox } from '../';

class MarketsContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this._onChangeSearch = this._onChangeSearch.bind(this);
    this.state = {
      search: '',
    };
  }
  render() {
    const { search } = this.state;
    return (
      <Container>
        <SearchBox onChangeSearch={this._onChangeSearch} />
        <MarketsTable filter={search} />
      </Container>
    );
  }

  _onChangeSearch(e, d) {
    const search = d.value;
    this.setState({
      search,
    });
  }
}

export default MarketsContainer;



// WEBPACK FOOTER //
// ./src/containers/Markets/components/MarketsContainer/index.jsx